import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15.998 3.934a9 9 0 1 1 -3.998 -.934v13","key":"svg-0"}],["path",{"d":"M16 12l-4 4l-4 -4","key":"svg-1"}]]

const IconCircleOpenArrowDown = createReactComponent('outline', 'circle-open-arrow-down', 'CircleOpenArrowDown', __iconNode);

export default IconCircleOpenArrowDown;